import React from 'react';
import ReactModal from 'react-modal';
import { Button } from 'modules/af_cm_ui_kit/components';
import { Props } from './UWModal.types';
import getStyle from './UWModal.styles';
import styles from './UWModal.module.scss';

ReactModal.setAppElement('#root');

const UWModal: React.FC<Props> = ({ children, isOpen, onCloseButtonClick, title }) => {
  return (
    <ReactModal style={getStyle(ReactModal.defaultStyles)} isOpen={isOpen}>
      <div className={styles.header}>
        <h2>{title}</h2>
        <Button mode="secondary" onClick={onCloseButtonClick}>
          Close
        </Button>
      </div>
      {children && <div className={styles.content}>{children}</div>}
    </ReactModal>
  );
};

export default UWModal;
